// deviceDetector.js

export function setDeviceAttributes(target = document.body) {
  const width = window.innerWidth;
  const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  const ua = navigator.userAgent.toLowerCase();

  // Détermination du mode (mobile / tablet / desktop + touch)
  let mode = 'desktop';
  if (width <= 767) {
    mode = 'mobile';
  } else if (width <= 1024) {
    mode = 'tablet';
  }
  if (isTouch) {
    mode += '-touch';
  }

  // Détection de l’OS
  let device = 'unknown';
  if (/android/.test(ua)) {
    device = 'android';
  } else if (/iphone|ipad|ipod/.test(ua)) {
    device = 'ios';
  } else if (/win/.test(ua)) {
    device = 'windows';
  } else if (/mac/.test(ua)) {
    device = 'mac';
  } else if (/linux/.test(ua)) {
    device = 'linux';
  }

  // Détection de l’orientation via matchMedia
  let orientation = 'portrait';
  if (window.matchMedia) {
    orientation = window.matchMedia('(orientation: landscape)').matches ? 'landscape' : 'portrait';
  } else {
    // Fallback si matchMedia indisponible
    orientation = window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
  }

  // Appliquer les attributs
  target.setAttribute('data-device-mode', mode);
  target.setAttribute('data-device', device);
  target.setAttribute('data-device-orientation', orientation);
}

export function initDeviceDetector(target = document.body) {
  const apply = () => setDeviceAttributes(target);

  window.addEventListener('DOMContentLoaded', apply);
  window.addEventListener('resize', apply);
  window.addEventListener('orientationchange', apply); // utile sur mobile

  // Bonus : écoute du media query orientation si supporté
  if (window.matchMedia) {
    const orientationQuery = window.matchMedia('(orientation: landscape)');
    orientationQuery.addEventListener('change', apply);
  }
}
